__turbopack_context__.v({
  "bar": "QbQpHG_bar",
  "daysLeft": "QbQpHG_daysLeft",
  "divider": "QbQpHG_divider",
  "period": "QbQpHG_period",
  "points": "QbQpHG_points",
  "pointsLabel": "QbQpHG_pointsLabel",
  "pointsValue": "QbQpHG_pointsValue",
  "progressFill": "QbQpHG_progressFill",
  "progressTrack": "QbQpHG_progressTrack",
  "summaryBtn": "QbQpHG_summaryBtn",
});
